exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-tips[data-v-11ba3728] {\n  margin-bottom: 22px;\n}\n.pagination-wrap[data-v-11ba3728] {\n  text-align: right;\n  padding: 30px 20px;\n}\n", ""]);

// exports
